var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/card.css';
let Card = class Card extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.image = '';
        this.href = undefined;
        this.target = '_self';
        this.img_position = 'start';
        this.selectable = '';
        this.disabled = '';
        this.icon = 'fas fa-check-circle';
        this._handleOutsideClick = (e) => {
            if (e.target == this && this.disabled != 'true') {
                this.shadowRoot?.querySelector('.card').classList.toggle('selected');
            }
        };
        this.checkDisabled = () => {
            if (this.disabled == 'true') {
                return 'disabled';
            }
            return '';
        };
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.selectable) {
            this.addEventListener('click', this._handleOutsideClick);
        }
    }
    firstUpdated() {
        let gs1CardContainer = this.shadowRoot?.querySelector('.card-body');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1CardContainer.appendChild(item);
            }
        });
    }
    clickRedirect() {
        if (this.href && this.disabled != 'true') {
            window.open(this.href, this.target);
        }
    }
    render() {
        var disabledClass = this.checkDisabled();
        var cursor_style = '';
        var img_pos = '';
        var icon_family = this.icon.split(' ')[0];
        var icon_type = this.icon.split(' ')[1];
        if (this.type.includes('is-horizontal')) {
            if (this.img_position == 'end') {
                img_pos = 'card-img-right';
            }
            else {
                img_pos = 'card-img-left';
            }
        }
        else {
            if (this.img_position == 'end') {
                img_pos = 'card-img-bottom';
            }
            else {
                img_pos = 'card-img-top';
            }
        }
        if (this.href && this.disabled != 'true') {
            cursor_style = 'pointer';
        }
        return html `
    ${env.debug ? html `<link rel="stylesheet" href="/css/card.css" />` : html ``}

    <div class="card ${this.type} ${disabledClass}" @click="${this.clickRedirect}" style="cursor: ${cursor_style}">
      <gs1-fa-icon class="card-icon" family="${icon_family}" type="${icon_type}"></gs1-fa-icon>
      ${this.img_position == 'end' ? html `<div class="card-body"></div>` : html ``}
      ${this.image != "" ? html `<img src="${this.image}" class="${img_pos}" alt="image">` : html ``}
      ${this.img_position == 'start' ? html `<div class="card-body"></div>` : html ``}
    </div>`;
    }
};
__decorate([
    property()
], Card.prototype, "type", void 0);
__decorate([
    property()
], Card.prototype, "image", void 0);
__decorate([
    property()
], Card.prototype, "href", void 0);
__decorate([
    property()
], Card.prototype, "target", void 0);
__decorate([
    property()
], Card.prototype, "img_position", void 0);
__decorate([
    property()
], Card.prototype, "selectable", void 0);
__decorate([
    property()
], Card.prototype, "disabled", void 0);
__decorate([
    property()
], Card.prototype, "icon", void 0);
Card = __decorate([
    customElement('gs1-card')
], Card);
export { Card };
//# sourceMappingURL=card.js.map